import { useEffect } from 'react';
import queryString from 'qs';
import { withRouter, Redirect } from 'react-router';
import { useMediaQuery } from 'react-responsive';

import WelcomeLogin from './WelcomeLogin';
import useAuthentication from 'hooks/useAuthentication';

import * as OktaConfig from 'constants/config/okta';
import validateFromURI, { validateInnerRoute } from 'utilities/validateFromURI';
import Logger from 'utilities/logger';

const Login = props => {
  const { location } = props;
  const { search = '' } = location;
  const { login, fromURI, hide } = queryString.parse(search.slice(1));
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });
  const { login: authenticated, storage } = useAuthentication();
  const logger = Logger('login');

  useEffect(() => {
    window.onbeforeunload = null;
    logger.debug({ fromURI, login });
    storage.removeItem('redirect1099');
    if (fromURI && validateFromURI(fromURI)) {
      storage.setItem('redirect', fromURI);
    } else {
      const redirectUrl = storage.getItem('redirect');

      if (!validateInnerRoute(redirectUrl)) {
        storage.removeItem('redirect');
      }
    }
  }, []);

  if (authenticated) {
    return <Redirect push exact to="/" />;
  }

  return (
    <WelcomeLogin
      login={login && decodeURIComponent(login)}
      oktaConfig={OktaConfig.getOktaConfig()}
      hideRegister={hide === 'register'}
      smsRecovery={true}
      isMobile={isMobile}
    />
  );
};

export default withRouter(Login);
